import { render, staticRenderFns } from "./alarm-severity.vue?vue&type=template&id=1a97896c&scoped=true&"
import script from "./alarm-severity.vue?vue&type=script&lang=js&"
export * from "./alarm-severity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a97896c",
  null
  
)

export default component.exports